import { type JSX } from 'react/jsx-runtime';

import { RovoOnboardingBanner } from '../../in-app-v2/confluence-side-nav/components/rovo-onboarding-banner';
import { createRender, type HydrationResult } from './types';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(({ rovoOnboardingUrl, onDismissed }) => {
	return (
		<RovoOnboardingBanner
			action="ROVO_EXTENSION_CTA"
			onPrimaryActionClick={() => rovoOnboardingUrl}
			onDismissClick={onDismissed}
		/>
	);
});

export default render;
